import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useShopPageContainer as useCoreShopPageContainer } from "@b2bportal/core-hotels";
import { AccountSelectors } from "@/modules/account";

export const useShopPageContainer = ({
  goToNextStep,
}: {
  goToNextStep: () => void;
}) => {
  const { context, handlers, text } = useCoreShopPageContainer({
    goToNextStep,
  });

  const isRewardsLoading = useSelector(AccountSelectors.isRewardsLoading);

  return useMemo(() => {
    return {
      context: {
        ...context,
        isLoading: isRewardsLoading || context.isLoading,
      },
      handlers,
      text,
    };
  }, [context, handlers, text, isRewardsLoading]);
};
